import videojs from 'video.js';
import '@devmobiliza/videojs-vimeo/dist/videojs-vimeo.esm';
import 'video.js/dist/video-js.min.css';

export default class VideoPlayer {
  static selectorString() {
    return '.js-video-player';
  }

  constructor(rootNode, props) {
    VideoPlayer.videos = [];

    const video = rootNode;
    const id = video.querySelector('.video-js').getAttribute('id');

    const options = {};

    videojs(id, options, function onPlayerReady() {});

    const $ = jQuery;
    $('.preview-picture-container').each(function() {
      $(this).on('click', function (e) {
        e.preventDefault();
        $('.preview-box').each(function() {
          $(this).removeClass('active');
        });
        $(this).closest('.preview-box').addClass('active');
        videojs(id).currentTime($(this).attr('data-time'));
        videojs(id).play();
      });
    });

    const param = VideoPlayer.getParameterByName('chapter');
    if (param) {
      const videoBox = $('#' + param);
      videoBox.addClass('active');
      setTimeout(function() {
        videojs(id).currentTime(videoBox.find('.preview-picture-container').attr('data-time'));
        videojs(id).play();
      }, 1000);
    }
  }

  static getParameterByName(name, url = window.location.href) {
    name = name.replace(/[\[\]]/g, '\\$&');
    const regex = new RegExp('[?&]' + name + '(=([^&#]*)|&|#|$)'),
      results = regex.exec(url);
    if (!results) return null;
    if (!results[2]) return '';
    return decodeURIComponent(results[2].replace(/\+/g, ' '));
  }

  /**
   * Play video
   * @param video
   */
  static playVideo(video) {
    const id = video.getAttribute('id');
    const player = videojs(id);
    player.play();
  }

  /**
   * Pause video
   * @param video
   */
  static stopVideo(video) {
    const id = video.getAttribute('id');
    const player = videojs(id);
    player.pause();
  }
}
